import { Controller } from "stimulus";
import { setVisibility } from "../helpers/stimulus";

export default class extends Controller {
  static targets = ["authorFields", "authorFieldsCheckbox"];

  connect() {
    this.toggleReportAuthorFields();
  }

  toggleReportAuthorFields() {
    this._toggle(this.authorFieldsTarget, this.authorFieldsCheckboxTarget);
    this.authorFieldsCheckboxTarget.value = Number(this.authorFieldsCheckboxTarget.checked);
  }

  _toggle(target, checkbox, negative = false) {
    if (negative) {
      setVisibility(target, !checkbox.checked);
    } else {
      setVisibility(target, checkbox.checked);
    }
  }
}
